"use client";
import React, { useEffect, useState } from "react";

//=== Packages == //

import Image from "next/image";

//=== Images == //
import product from "../media/Session-img.png";

//=== Components == //
import Buttons from "../compononents/Button/Button";
import SideDrawer from "../compononents/SideDrawer/SideDrawer";
import Payment from "../forms/Payment";
import PaymentPlan from "./PaymentPlan";
import ShoppingCartListing from "../compononents/ShoppingCartListing/ShoppingCartListing";
import OrderSummary from "./OrderSummary";
import { getUserData } from "../../../hooks/HelperFunctions";
import { useShoppingCart } from "../../../contexts/CartContext";
import { usePathname } from "next/navigation";

export default function CoursesQuantity({
  seletedCartItemId,
  setOpenCoursesQuantityDrawer,
  setCartItems,
  cartItems,
  setOpenSignUpModel,
}) {
  const [shoppingData, setShoppingData] = useState([]);
  const [totalPriceToShow, setTotalPriceToShow] = useState(0);
  const [paymentData, setPaymentData] = useState({
    userId: "",
    courseIdsCheckout: "",
    tracksAndTerms: [],
  });
  const [courses, setCourses] = useState([]);
  const getOnlyCourses = cartItems?.filter((course) => course?.courseId);
  const [courseIds, setCourseIds] = useState(() => {
    return cartItems
      ? Object.keys(getOnlyCourses)
          .map(function (k) {
            return getOnlyCourses[k]["courseId"];
          })
          .join("-")
      : "";
  });

  const API_URL =
    process.env.NEXT_PUBLIC_PROJECT_ENV === "prod"
      ? process.env.NEXT_PUBLIC_API_URL_PROD
      : process.env.NEXT_PUBLIC_API_URL_DEV;

  const baseUrl = typeof window !== "undefined" ? window.location.origin : "";
  const pathname = usePathname();

  // ====== Payment Drawer Start======//
  const [openPaymentDrawer, setOpenPaymentDrawer] = useState(false);
  // const handleOpenPaymentDrawer = () => {
  //   setOpenPaymentDrawer(true);
  // };
  const ClosePaymentDrawer = () => {
    setOpenPaymentDrawer(false);
  };
  // ====== Payment Drawer End======//

  // ====== Payment Plan Drawer Start======//
  const [openPlanDrawer, setOpenPlanDrawer] = useState(false);
  const handleOpenPlanDrawer = () => {
    setOpenPlanDrawer(true);
  };
  const ClosePlanDrawer = () => {
    setOpenPlanDrawer(false);
  };
  // ====== Payment Plan Drawer End======//

  {
    /* === Selected Courses Quantity Details Drawer=== */
  }
  // const [CoursesQuantityDrawer, setOpenCoursesQuantityDrawer] = useState(false);
  // const handleOpenCoursesQuantityDrawer = () => {
  //   setOpenCoursesQuantityDrawer(true);
  // };
  // const ClosePlanCoursesQuantityDrawer = () => {
  //   setOpenCoursesQuantityDrawer(false);
  // };
  // {
  //   /* === Selected Courses Quantity Details Drawer=== */
  // }

  const [cartShoppingCourseData, setCartShoppingCourseData] = useState([]);
  const [removeCartItemId, setRemoveCartItemId] = useState("");
  useEffect(() => {
    let empty = [];
    if (seletedCartItemId) {
      setCartShoppingCourseData(seletedCartItemId?.courses);
    } else {
      setCartShoppingCourseData(empty);
      setOpenCoursesQuantityDrawer(true);
    }
  }, [seletedCartItemId]);

  useEffect(() => {
    if (cartItems?.length > 0) {
      let coursesArray = [];
      cartItems?.map((singleCourseTrack) => {
        if (singleCourseTrack?.track_id && singleCourseTrack?.track_id > 0) {
          singleCourseTrack?.courses?.map((singleCourse) => {
            coursesArray.push(singleCourse?.course);
          });
        } else {
          coursesArray.push(singleCourseTrack);
        }
      });
      setCourses(coursesArray);
    }
  }, [cartItems]);

  useEffect(() => {
    let empty = [];
    if (cartShoppingCourseData?.length > 0) {
      setShoppingData(showData(cartShoppingCourseData));
    } else {
      setShoppingData(showData(empty));
      setOpenCoursesQuantityDrawer(true);
    }
  }, [cartShoppingCourseData]);

  //================================= listing data =========================================//
  //================================= get toatl price ======================================//

  const totalData = (courseData) => {
    let totalPrice = courseData?.reduce((total, data) => {
      if (
        data &&
        data?.trackTermCoursesTotalPrice !== null &&
        data?.trackTermCoursesTotalPrice !== undefined
      ) {
        let singleTrackCoursesSelectedPrice = 0;
        data?.courses?.map((course) => {
          singleTrackCoursesSelectedPrice +=
            course?.course?.price && course.course.priceCat !== "Free"
              ? parseFloat(course?.course?.price)
              : 0;
        });
        total += parseFloat(singleTrackCoursesSelectedPrice);
      } else if (data && data?.price !== null && data?.price !== undefined) {
        total += parseFloat(data?.price);
      }

      return total;
    }, 0);
    return totalPrice || 0;
  };

  //================================= get toatl price ======================================//
  //================================= handleRemove data ==================================//
  const handleRemove = (id) => {
    setRemoveCartItemId(id);
  };
  //================================= handleRemove data ==================================//

  useEffect(() => {
    if (removeCartItemId) {
      let latestCartItem = cartShoppingCourseData?.filter(
        (cartItem) => cartItem?.id !== parseInt(removeCartItemId)
      );
      setCartShoppingCourseData(latestCartItem);
      // seletedCartItemId.courses = latestCartItem;
      let foundItemPrice = cartShoppingCourseData?.find(
        (cartItem) => cartItem?.id === parseInt(removeCartItemId)
      );
      const storedTacksToShopping = JSON.parse(
        localStorage.getItem("cartPaymentInfo") || "[]"
      );

      // Check if latestCartItem is empty
      if (latestCartItem && latestCartItem.length > 0) {
        const updatedStoredTacksToShopping = storedTacksToShopping.map(
          (item) => {
            if (item.id === seletedCartItemId.id) {
              const updatedItem = {
                ...item,
                courses: latestCartItem,
                trackTermCoursesTotalPrice: totalData(latestCartItem),
              };
              // Debugging line
              return updatedItem;
            }
            return item;
          }
        );

        setCartItems(updatedStoredTacksToShopping);
        localStorage.setItem(
          "cartPaymentInfo",
          JSON.stringify(updatedStoredTacksToShopping)
        );
      } else {
        // Remove the item from storedTacksToShopping if latestCartItem is empty
        const updatedStoredTacksToShopping = storedTacksToShopping.filter(
          (item) => item.id !== seletedCartItemId.id
        );
        setCartItems(updatedStoredTacksToShopping);
        localStorage.setItem(
          "cartPaymentInfo",
          JSON.stringify(updatedStoredTacksToShopping)
        );
      }
    } else if (cartItems) {
      setCartItems(cartItems);
    }
  }, [removeCartItemId, seletedCartItemId]);

  const showData = (arr) => {
    if (arr?.length > 0) {
      return arr?.map((item) => {
        return {
          Img: item?.course?.courseImage ? item?.course?.courseImage : product,
          Title: item?.course?.courseTitle,
          Description: item?.course?.organization?.teachingAccName,
          // OldPrice: "$4000",
          NewPrice: `$${
            item?.course?.price && item.course.priceCat !== "Free"
              ? parseFloat(item?.course?.price)?.toFixed(2)
              : " 0.00"
          }`,
          Remove: true,
          onClickRemove: (e) => handleRemove(item?.id),
          SaveForLater: false,

          AddProductCoupon: false,
        };
      });
    } else {
      return [];
    }
  };
  //================================= listing data =========================================//
  // const shoppingData = [

  //   {
  //     Img: product,
  //     Title:
  //       "On The Timing and Virtues of the Night of Power: The Heart's Joy in Remembering Laylat al-Qadr",
  //     Description: "Hikmah Academy of California",
  //     OldPrice: "$4000",
  //     NewPrice: "$3600",
  //     Remove: true,
  //     //onClickRemove:onClickRemove,
  //     SaveForLater: true,

  //     AddProductCoupon: true,
  //   },

  //   {
  //     Img: product,
  //     Title:
  //       "On The Timing and Virtues of the Night of Power: The Heart's Joy in Remembering Laylat al-Qadr",
  //     Description: "Hikmah Academy of California",
  //     OldPrice: "$4000",
  //     NewPrice: "$3600",
  //     Remove: true,
  //     //onClickRemove:onClickRemove,
  //   },

  //   {
  //     Img: product,
  //     Title:
  //       "On The Timing and Virtues of the Night of Power: The Heart's Joy in Remembering Laylat al-Qadr",
  //     Description: "Hikmah Academy of California",
  //     OldPrice: "$4000",
  //     NewPrice: "$3600",
  //     Remove: true,
  //     //onClickRemove:onClickRemove,
  //   },
  // ];

  const handleOpenPaymentDrawer = () => {
    if (cartItems?.length === 0) {
      return;
    }

    const empty = [];
    const userAuthenticated = localStorage.getItem("userAuthenticated");
    if (userAuthenticated == "true") {
      const userData = getUserData();
      const userId = userData.id;
      const trackPriceId = localStorage.getItem("trackPriceId");
      const sendingTrackId = localStorage.getItem("trackId");
      const courseIdsCheckout = courseIds.length > 0 ? courseIds : "";
      const tracksAndTermsData = cartItems.map((term) => ({
        trackId: term?.trackId,
        terms: [
          {
            termId: term?.id || "",
            courseIds: term?.courses?.map((course) => course.courseId) || "",
          },
        ],
      }));

      const tracksAndTerms = tracksAndTermsData?.filter(
        (items) => items?.trackId !== undefined
      );
      const encodedTermsAndCourses = encodeURIComponent(
        JSON.stringify(tracksAndTerms)
      );
      setPaymentData({
        ...paymentData,
        userId: userId,
        courseIdsCheckout: courseIdsCheckout,
        tracksAndTerms: tracksAndTerms,
      });

      const checkoutBackEndUrl = `${API_URL}/checkoutTracksAndIndependentCourses?userId=${userId}&independentCourseIds=${courseIdsCheckout}&tracksAndTerms=${
        tracksAndTerms?.length > 0 ? encodedTermsAndCourses : ""
      }&frontEndUrl=${
        pathname === "/shopping"
          ? `${baseUrl.replace(/\/shopping$/, "")}`
          : baseUrl
      }`;

      setOpenPaymentDrawer(true);
      return false;

      window.location.replace(checkoutBackEndUrl);
    } else {
      // localStorage.setItem("cartPaymentInfo", JSON.stringify(empty));
      setOpenSignUpModel(true);
    }
  };

  useEffect(() => {
    let coursesArrayNew = [];
    let totalPrice = 0;
    courses?.map((singleCourse) => {
      coursesArrayNew.push({
        img: singleCourse?.courseImage,
        title: singleCourse?.courseTitle,
        price: singleCourse?.price,
      });
      if (
        singleCourse?.price &&
        singleCourse?.price > 0 &&
        singleCourse.priceCat !== "Free"
      ) {
        totalPrice += singleCourse?.price;
      }
    });
    setTotalPriceToShow(totalPrice);
    // setShoppingData(coursesArrayNew);
  }, [courses]);

  return (
    <>
      <div className="PM_ShoppingCartContainer">
        <div className="TotalCoursesDetailsSection">
          <div className="TotalCoursesDetailsSectionInner">
            <div className="TotalCoursesDetailsLeft">
              <h1>
                {seletedCartItemId?.name} : {seletedCartItemId?.trackTermName}
              </h1>
              {/* <p>Hikmah Academy of California</p> */}
            </div>

            <div className="TotalCoursesDetailsRight">
              <h2>
                ${parseFloat(totalData(cartShoppingCourseData))?.toFixed(2)}
              </h2>
            </div>
          </div>
        </div>

        <ShoppingCartListing
          shoppingData={shoppingData}
          EnterProductCouponCodeValue="abc"
          BrowsingLink="/"
          CurrencySign="$"
          onClickCheckout={() => handleOpenPaymentDrawer()}
          Total={parseFloat(totalPriceToShow)?.toFixed(2)}
        />

        {/* === Payment Drawer Start*/}
        <SideDrawer
          drawerWidth="744px"
          padding="24px"
          title="Checkout"
          sideOpen="right"
          open={openPaymentDrawer}
          handleDrawerClose={ClosePaymentDrawer}
          Headerbackground="#004FE0"
          HeaderTextColor="#fff"
          DrawerWidth="870px"
          SubDrawer="SubDrawer"
          body={
            <Payment
              courses={courses}
              cartItems={cartItems}
              paymentData={paymentData}
              totalPriceToShow={totalPriceToShow}
              setOpenPaymentDrawer={setOpenPaymentDrawer}
            />
          }
          SubDrawerbody={
            <OrderSummary
              courses={courses}
              cartItems={cartItems}
              paymentData={paymentData}
              shoppingData={shoppingData}
              totalPriceToShow={totalPriceToShow}
              setOpenPaymentDrawer={setOpenPaymentDrawer}
            />
          }
        />
      </div>
    </>
  );
}
